


export const getLogs = async (restAPI, type) => {
  let response = await restAPI.get("/logs?type=" + type);
  return response.data;
};